/*
 * @Author: chen_yong
 * @Date: 2020-04-21 20:29:08
 * @Version: 1.0.0
 * @LastEditTime: 2021-02-20 17:10:32
 * @Description: 
 */
export default {
  // 通用基础接口
  common: {
    // 当前登录用户的权限
    login: '/exhibition/loginCheck',
    tokenCheck: '/exhibition/tokenCheck',
    logout: '/logout',
    oss: '/exhibition/getOssAuth',
    checkCode: '/getMobilCode',

  },
  exhibition: {
    list: '/exhibition/exhibitionMasters',
    add: '/exhibition/add',
    getModel: '/exhibition/getExhibitionInfoById',
    update: '/exhibition/update',
    getMasterModel: '/exhibition/getMasterInfoById',
    stores: '/exhibition/exhibitionStores',
    getStoreModel: '/exhibition/getExhibitionStoreById',
    getSwiper: "/exhibition/getSwiperById",
    swipersIndex: "/exhibition/getSwipersIndex",
    sendEmail: '/exhibition/sendEmail',
  }
}



// WEBPACK FOOTER //
// ./src/common/apis.js